import { FC } from "react";

import Box from "@mui/material/Box";
import { Theme } from "@mui/material/styles";

import { DashboardInfobox, InfoboxProps } from "@/dashboard-design-system/Infobox";
import Nofie from "@/icons/illustration/nofie.svg";

const leftSlotContainerSx = {
  width: "82px",
  position: "relative",
  overflow: "hidden",
};

const leftSlotChildSx = (theme: Theme) => ({
  position: "absolute",
  overflow: "hidden",
  top: theme.spacing(2),
  right: 0,
  left: 0,
});

export const NofieInfobox: FC<InfoboxProps> = ({ hideIcon = true, slots, vibe = "neutral", ...rest }) => (
  <DashboardInfobox
    {...rest}
    hideIcon={hideIcon}
    titleVariant="h6"
    slots={{
      ...slots,
      left: slots?.left ?? (
        <Box sx={leftSlotContainerSx}>
          <Box sx={leftSlotChildSx}>
            <Nofie width="100%" height="100%" />
          </Box>
        </Box>
      ),
    }}
    vibe={vibe}
  />
);
